module.exports = __webpack_public_path__ + "img/McBean.fbaac67b.png";